import React from "react";
import styled from "styled-components";

const StyledContainer = styled.div`
  color: ${({ theme }) => theme.colors.darkText};
  max-width: 850px;
`;

const Container = ({ children }) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default Container;
